import React from 'react';
import { observer } from 'mobx-react-lite';

import { TagItem } from './TagItem';
import { Tag } from '@models/Tags/TagModel';
import { FlatList, IFlatListProps } from '../common/FlatList';
import { Separator } from '../common/Separator';

export interface ITagHorizontalListProps
  extends Omit<IFlatListProps<Tag>, 'renderItem' | 'horizontal'> {
  data: Tag[] | undefined;
  onPress(item: Tag): void;
}

export const TagHorizontalList = observer(
  ({ data, onPress, ...props }: ITagHorizontalListProps) => {
    return (
      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        data={data}
        renderItem={({ item }) => (
          <TagItem item={item} onPress={onPress} />
        )}
        keyExtractor={(i) => i.id.toString()}
        ItemSeparatorComponent={() => (
          <Separator size="$4" vertical />
        )}
        {...props}
      />
    );
  },
);
